
define('CustomMerchZone.EntryPoint',
  [
    'CustomMerchZone.View'
  ],
  function (
    CustomMerchZoneView
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var layout = container.getComponent('Layout');
        var userProfile = container.getComponent('UserProfile');
        var environment = container.getComponent('Environment');
        var config = container.getConfig('customMerchZone');
        var plp = container.getComponent('PLP');
        var supplierIds = [];
        _.each(config.CustomMerchZone.suppliers, function (suppliers) {
          supplierIds.push(suppliers.supplierid);
        });
        var pricingGroups = [];
        _.each(config.CustomMerchZone.groupPricing, function (pricing) {
          var pricingData = {
            manufacturerId: pricing.manufacturer,
            groupPricingId: pricing.groupPricingId
          };
          pricingGroups.push(pricingData);
        });
        if (layout && userProfile && environment) {
          userProfile.getUserProfile().then(function (profile) {
            if (profile) {
              layout.addChildView('UC.Custom.Merch.Zone', function () {
                return new CustomMerchZoneView({
                  profile: profile,
                  container: container,
                  isLoggedIn: profile.isloggedin,
                  priceLevel: profile.pricelevel,
                  environment: environment,
                  pricingGroups: pricingGroups,
                  plp: plp,
                  suppliers: supplierIds
                });
              });
            }
          });
        }
      }
    };
  });
